export const fillRange = (pointsFrom: number, pointsTo: number): number[] => {
  const array: number[] = []
  for (let i = pointsFrom; i <= pointsTo; i++) {
    array.push(i)
  }

  return array
}
